<template>
  <div>
    <div class="row mx-4">
      <div class="col-xs-12">
        <h4 style="color:#2E7D32;">
          {{ form.export_order_id ? $t('customer.updateExportOrderTitleWithNumber', { number: form.order_number }) : $t('customer.requestExportOrderTitle') }}
        </h4>
      </div>
    </div>

    <div
      class="col-md-12"
      style="border-bottom-style: solid; border-width: 2px; border-color: #388E3C"
    />

    <form @submit.prevent="submitForm()">
      <v-alert
        type="success"
        :value="checkAlert"
      >
        {{ $t('customer.requestedSuccessfullyMessage') }}
      </v-alert>

      <div class="row mx-4">
        <div class="col-md-12">
          <v-text-field
            :label="$t('customer.productDescription') + '*'"
            v-model="form.product_name"
            :error-messages="errors.collect('Product Description')"
            v-validate="'required'"
            data-vv-name="Product Description"
          />
        </div>

        <div class="col-md-6">
          <v-text-field
            :label="$t('columns.quantity') + '*'"
            v-model="form.quantity"
            :error-messages="errors.collect('Quantity')"
            v-validate="'required|numeric|min_value:1'"
            data-vv-name="Quantity"
          />
        </div>

        <div class="col-md-5">
          <v-text-field
            :label="$t('columns.weight')"
            v-model="form.weight"
          />
        </div>
        <div class="col-xs-1">
          <v-select
            :items="weightUnitList"
            v-model="form.weight_unit"
            :error-messages="errors.collect('Weight Unit')"
            data-vv-name="Weight Unit"
            v-validate="'required'"
            autocomplete
          />
        </div>

        <div class="col-xs-12">{{ $t('customer.dimensionsPerPackageLabel') }} <span class="inch-div">(inch)</span></div>
        <div class="col-xs-3">
          <v-text-field
            v-model="form.volume_l"
            :label="$t('customer.length')"
            type="number"
          />
        </div>
        <div class="col-xs-3">
          <v-text-field
            v-model="form.volume_w"
            :label="$t('customer.width')"
            type="number"
          />
        </div>
        <div class="col-xs-3">
          <v-text-field
            v-model="form.volume_h"
            :label="$t('customer.height')"
            type="number"
          />
        </div>
        <div class="col-xs-3">
          <input
            type="file"
            accept="image/*"
            name="image"
            id="image"
            style="display: none"
            @input="form.image = $event.target.files[0]"
          >
          <label
            for="image"
            class="btn btn-primary"
          >
            <i class="fa fa-upload"></i> {{ $t('orders.uploadImage') }}
            <i class="pl-1">{{ form.image ? form.image.name : '' }}</i>
          </label>
        </div>
      </div>

      <v-divider></v-divider>

      <div class="row mx-4">
        <div class="col-xs-12">
          <div style="font-size: 16px">{{ $t('customer.receiverDetail') }}</div>
        </div>

        <div class="col-md-6">
          <v-text-field
            :label="$t('columns.name') + '*'"
            v-model="form.receiver_name"
            :error-messages="errors.collect('Name')"
            v-validate="'required'"
            data-vv-name="Name"
          />
        </div>

        <div class="col-md-6">
          <v-text-field
            :label="$t('columns.phone') + '*'"
            v-model="form.receiver_phone"
            :error-messages="errors.collect('Phone')"
            v-validate="'required'"
            data-vv-name="Phone"
          />
        </div>

        <div class="col-md-6">
          <v-text-field
            :label="$t('columns.address') + '*'"
            v-model="form.receiver_address"
            :error-messages="errors.collect('Address')"
            v-validate="'required'"
            data-vv-name="Address"
          />
        </div>

        <div class="col-md-6">
          <v-text-field
            :label="$t('columns.city') + '*'"
            v-model="form.receiver_city"
            :error-messages="errors.collect('City')"
            v-validate="'required'"
            data-vv-name="City"
          />
        </div>

        <div class="col-md-6">
          <v-text-field
            :label="$t('customer.zipCode') + '*'"
            v-model="form.receiver_zip_code"
            :error-messages="errors.collect('Zip Code')"
            v-validate="'required'"
            data-vv-name="Zip Code"
          />
        </div>

        <div class="col-md-6">
          <v-select
            autocomplete
            :items="countryList"
            item-value="value"
            v-model="form.to_country_id_fk"
            :error-messages="errors.collect('Destination')"
            data-vv-name="Destination"
            :label="$t('customer.destination') + '*'"
            v-validate="'required'"
          />
        </div>

        <div class="col-md-6">
          <v-text-field
            :label="$t('columns.email') + '*'"
            type="email"
            v-model="form.receiver_email"
          />
        </div>
      </div>

      <v-spacer></v-spacer>

      <div class="col-sm-10 col-md-6 col-md-offset-3">
        <v-btn
          type="submit"
          :loading="loading"
          style="width: 100%; height:auto; margin-bottom: 3%"
          color="success"
        >
          {{ form.export_order_id ? $t('common.update') : $t('customer.requestButton') }}
        </v-btn>
      </div>
    </form>
  </div>
</template>
<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {

  mounted() {
    this.getCountryList()

    // if edit mode get order data
    if (this.$route.params.id) {
      this.getOrder()
    }
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      weightUnitList: [
        { text: 'KG', value: 'kg' },
        { text: 'LB', value: 'lb' }
      ],
      countryList: [],
      checkAlert: false,
      loading: false,
      form: {
        product_name: null,
        quantity: null,
        weight: null,
        image: null,
        weight_unit: 'kg',
        volume_l: null,
        volume_w: null,
        volume_h: null,
        receiver_name: null,
        receiver_phone: null,
        receiver_address: null,
        receiver_city: null,
        receiver_zip_code: null,
        to_country_id_fk: null,
        receiver_email: null
      }
    }
  },

  methods: {
    getCountryList() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/country/list', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.countryList = response.data.map((item) => {
            return { text: item.country_name, value: item.country_id }
          })
        })
    },

    getOrder() {
      let token = localStorage.getItem('access_token')
      axios
        .get(`api/customer_order_detail/${this.$route.params.id}`, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.form = response.data.data[0]
        })
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          let token = localStorage.getItem('access_token')

          let formData = new FormData()
          for (let key in this.form) {
            if (this.form[key]) {
              formData.append(key, this.form[key])
            }
          }

          if (this.form.export_order_id) {
            formData.append('_method', 'put')
            axios
              .post(`api/export-order/${this.form.export_order_id}`, formData, {
                headers: { Authorization: 'Bearer ' + token }
              })
              .then(() => {
                this.loading = false
                this.checkAlert = true
                setTimeout(() => {
                  this.checkAlert = false
                  this.clearForm()
                  this.$router.push('/my-export-order')
                }, 2000)
              })
              .catch(error => {
                this.loading = false
                this.checkAlert = false
                swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
              })
          } else {
            axios
              .post('api/export-order', formData, { headers: { Authorization: 'Bearer ' + token } })
              .then(() => {
                this.loading = false
                this.checkAlert = true
                this.clearForm()
                setTimeout(() => {
                  this.checkAlert = false
                }, 2000)
              })
              .catch(error => {
                this.loading = false
                this.checkAlert = false
                swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
              })
          }
        }
      })
    },

    clearForm() {
      this.form = {
        product_name: null,
        quantity: null,
        weight: null,
        weight_unit: 'kg',
        volume_l: null,
        volume_w: null,
        volume_h: null,
        image: null,
        receiver_name: null,
        receiver_phone: null,
        receiver_address: null,
        receiver_city: null,
        receiver_zip_code: null,
        to_country_id_fk: null,
        receiver_email: null
      }

      this.$validator.reset()
    }
  }
}
</script>

<style scoped>

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.panel-flat {
  overflow-x: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/exportOrder/addExportOrder.vue